import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Timer that ticks every second and counts down from specified value
 */
export function useCountdown(duration: number, autostart: boolean = false) {
  const timerRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState<number>(duration);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  const start = useCallback(() => {
    setTimeLeft(duration);
    clearInterval(timerRef.current);
    setIsRunning(true);

    timerRef.current = setInterval(() => {
      setTimeLeft((current) => current - 1);
    }, 1000);
  }, []);

  const stop = useCallback(() => {
    clearInterval(timerRef.current);
    setIsRunning(false);
  }, []);

  useEffect(() => {
    // Stop the ticking once the time left reaches 0
    if (timeLeft < 1) {
      stop();
    }
  }, [timeLeft]);

  useEffect(() => {
    if (autostart) {
      start();
    }

    // Clear the ticking when the component is unmounted
    return () => stop();
  }, []);

  return { timeLeft, isRunning, start, stop };
}
